var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element.auth.indexOf(parseInt(_vm.$store.getters['auth/profile'].role)) >= 0)?_c('div',[_c('router-link',{attrs:{"to":_vm.element.route,"title":_vm.element.title}},[_c('i',{staticClass:"fas",class:_vm.element.icon})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }